import React, {FC} from "react";
import {Card, CardContent, CardProps, makeStyles} from "@material-ui/core";
import {FeClient} from "../redux/types";
import {useUpdateClient} from "../redux/clients.hook";
import {EditableName} from "../../../sharedComponents/EditableName";
import {LabeledTextDisplay} from "../../../sharedComponents/LabeledTextDisplay";
import {EditableTextField} from "../../../sharedComponents/EditableTextfield";

const useStyles = makeStyles((theme) => ({
    spacing: {
        marginBottom: theme.spacing(2)
    }
}))

interface ClientProfileCardProps {
    client?: FeClient;
    cardProps?: CardProps;
}

export const ClientProfileCard: FC<ClientProfileCardProps> = ({client, cardProps}) => {
    const classes = useStyles();
    const {updateClient} = useUpdateClient()

    return (
        <Card {...cardProps}>
            <CardContent>
                <EditableName
                    value={client}
                    onSubmit={updateClient}
                    className={classes.spacing}
                />
                <LabeledTextDisplay
                    label="Email"
                    type="email"
                    required
                    value={client?.email}
                    className={classes.spacing}
                />
                <LabeledTextDisplay
                    label="Kundennummer"
                    required
                    value={client?.clientNumber}
                    className={classes.spacing}
                />
                <EditableTextField
                    formProps={{
                        label: 'Firma',
                        initialValue: client?.companyName,
                        onSubmit: (value) => updateClient(client?.id || '', {companyName: value as string | undefined})
                    }}
                    editIdentifier="companyName"
                />
            </CardContent>
        </Card>
    )
}